export default "__VITE_ASSET__D_2I2HRS__"